export default __webpack_public_path__ + "static/media/NoAccess.96ed9a0c.svg";